















































import { PagesNavigationView, PdfConfiguration } from "@zoovu/runner-web-design-base";
import {
  Advisor,
  AdvisorNavigation,
  Component,
  FlowStep,
  InjectComponent,
  Prop,
  QAFlowStepsNavigation,
  Question,
  SectionType,
  Vue,
  VueComponent,
  FlowStepSubmitStatus,
  ComponentConfig,
} from "@zoovu/runner-browser-api";
import { IconBack, IconPdfDownload } from "./svgs";

@Component({
  name: "PagesNavigationView",
  components: { IconPdfDownload, IconBack },
  mixins: [PagesNavigationView],
})
export default class PagesNavigationViewExtended extends Vue {
  @Prop()
  navigation: AdvisorNavigation;

  @Prop({ default: true })
  showPageSelector: boolean;

  @Prop()
  advisor: Advisor;

  @Prop()
  alignment: string;

  @Prop({ default: true })
  back: boolean;

  @Prop({ default: true })
  next: boolean;

  @Prop({ default: false })
  restart: boolean;

  @InjectComponent("StartOverButtonView")
  startOverButtonView: VueComponent;

  @InjectComponent("PdfDownloadButtonView")
  pdfDownloadButtonView: VueComponent;

  @ComponentConfig(PdfConfiguration)
  pdfConfiguration: PdfConfiguration;

  get isPdfButtonVisible(): boolean {
    return this.pdfConfiguration.enabled && this.isResultsPage;
  }

  get currentFlowStep(): FlowStep {
    return (this.navigation.currentSection.navigation as QAFlowStepsNavigation).currentFlowStep;
  }

  get currentFirstQuestion(): Question {
    if (!this.currentFlowStep) return null;
    return this.currentFlowStep.questions[0];
  }

  get firstQuestionIsUnanswered(): boolean {
    return !!this.currentFirstQuestion?.isUnanswered;
  }

  get firstQuestionIsMandatory(): boolean {
    return !!this.currentFirstQuestion?.isMandatory;
  }

  get nextButtonShouldAppearDisabled(): boolean {
    return this.firstQuestionIsMandatory && this.firstQuestionIsUnanswered;
  }

  get nextButtonClasses(): ReadonlyArray<string | unknown> {
    const nextButtonStatusClass = this.navigation.isFetching ? "navigation-next-in-progress" : "navigation-next-button";
    return [
      nextButtonStatusClass,
      {
        "navigation-next-button--disabled-appearance": this.nextButtonShouldAppearDisabled,
      },
    ];
  }

  get questionCanBeSkipped(): boolean {
    return (
      !this.firstQuestionIsMandatory &&
      this.currentFlowStep &&
      this.currentFlowStep.submitStatus === FlowStepSubmitStatus.NOT_SUBMITTED &&
      this.firstQuestionIsUnanswered
    );
  }

  get nextButtonCaption(): string {
    return (this.isResultsSectionNext
      ? this.$t("message-results-mode-button")
      : this.$t("message-questionnaire-next")) as string;
  }

  get isResultsPage(): boolean {
    return this.advisor.advisorNavigation.currentSection.type === SectionType.RESULTS_PAGE;
  }

  get isFirstPage(): boolean {
    return this.advisor.flowStepsNavigation.currentStepIndex === 0;
  }
}
